import Text from "sap/m/Text";
import Util from "ips/ac/util/Util";
import Formatter from "ips/ac/data/planningcalendar/control/DeliveryAddressLabelFormatter";

interface IBindingPart {
  path: string;
  targetType: string;
}

export default class DeliveryAddressLabelTextProvider {
  private _sNameText?: Text;
  private _oPhoneText?: Text;
  private _oEmailText?: Text;
  private _oAddressText?: Text;

  getNameText(): Text {
    if (!this._sNameText) {
      const aParts: IBindingPart[] = [
        { path: "$order>/Firstname", targetType: "any" },
        { path: "$order>/Lastname", targetType: "any" },
      ];
      this._sNameText = this.getText(
        this._sNameText,
        aParts,
        Formatter.nameFormat,
        (sFirstname: string, sLastname: string) => !!Formatter.nameFormat(sFirstname, sLastname),
      );
    }
    return this._sNameText;
  }

  getPhoneText(): Text {
    if (!this._oPhoneText) {
      const aParts: IBindingPart[] = [
        { path: "$order>/Phone", targetType: "any" },
      ];
      this._oPhoneText = this.getText(
        this._oPhoneText,
        aParts,
        this._identityFormat,
        (sPhone: string) => !!sPhone,
      );
    }
    return this._oPhoneText;
  }

  getEmailText(): Text {
    if (!this._oEmailText) {
      const aParts: IBindingPart[] = [
        { path: "$order>/Email", targetType: "any" },
      ];
      this._oEmailText = this.getText(
        this._oEmailText,
        aParts,
        this._identityFormat,
        (sEmail: string) => !!sEmail,
      );
    }
    return this._oEmailText;
  }

  getAddressText(): Text {
    if (!this._oAddressText) {
      const aParts: IBindingPart[] = [
        { path: "$order>/Street", targetType: "any" },
        { path: "$order>/HouseNumber", targetType: "any" },
        { path: "$order>/Zip", targetType: "any" },
        { path: "$order>/City", targetType: "any" },
      ];
      this._oAddressText = this.getText(
        this._oAddressText,
        aParts,
        Formatter.addressFormat,
        (sStreet: string, sHouseNumber: string, sZip: string, sCity: string) =>
          !!Formatter.addressFormat(sStreet, sHouseNumber, sZip, sCity),
      );
    }
    return this._oAddressText;
  }

  private getText(
    oText: Text | undefined,
    aParts: IBindingPart[],
    fFormatter: (...aArgs: any[]) => any,
    fVisibleFormatter: (...aArgs: any[]) => boolean,
  ): Text {
    oText = new Text({
      text: {
        parts: aParts,
        formatter: fFormatter,
      },
      visible: {
        parts: aParts,
        formatter: fVisibleFormatter,
      },
      wrapping: false,
      maxLines: 1,
      tooltip: Util.getText("@DeliveryAddress"),
    });
    return oText;
  }

  private _identityFormat(sValue?: string | null): string | undefined {
    return sValue ?? undefined;
  }
}
